export default __webpack_public_path__ + "static/media/fail.2349d042.gif";